import { render, staticRenderFns } from "./AcsAddBtn.vue?vue&type=template&id=4f47984b&scoped=true&lang=pug&"
import script from "./AcsAddBtn.vue?vue&type=script&lang=js&"
export * from "./AcsAddBtn.vue?vue&type=script&lang=js&"
import style0 from "./AcsAddBtn.vue?vue&type=style&index=0&id=4f47984b&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f47984b",
  null
  
)

export default component.exports